import type { SimplifiedQuantzResponseDto } from './dto';
import type { RecordingEvent } from './model/RecordingEvent';

// The response will looks like that:
// NOTE: The response is ordered by created (desc) to retrieve the most recent events,
// and needs to be then alpha-sorted here.
// {
//   "data": {
//     "result_series":[
//       {
//         "key": "user_event_name",
//         "values": [
//           ["Clicked: Selected segment Contact Info page - Dashboard Recordings Card", 1668178594],
//           ...
//           ["Clicked: Nav toolbar - Account settings", 1662800194]
//         ]
//       }
//     ],
//     "total": null
//   },
//   "meta": {
//     "level": "event",
//     "operation": "count",
//     "resolution": null,
//     "success": true,
//     "windowed": false
//   }
// }
export function mapDtoToModel(dto: SimplifiedQuantzResponseDto): RecordingEvent[] {
  if (
    !dto?.data?.result_series ||
    dto?.data?.result_series.length === 0 ||
    dto.data.result_series[0].key !== 'user_event_name' ||
    dto.data.result_series[0].values == null
  ) {
    return [];
  }
  return dto.data.result_series[0].values
    .map((item) => {
      return {
        value: item[0],
      };
    })
    .sort((obj1, obj2) => obj1.value.localeCompare(obj2.value, undefined, { sensitivity: 'base' }));
}
